import { Position, State } from 'src/types'
import { catchFace } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/catchFace'
import { edges } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/edge'
import { hamidashi } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/hamidashi'
import { listLining } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/listLining'
import { lace } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/lace'
import { thumbBackOut, thumbBackWebSide } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/back/thumbFinger'
import { indexBackMiddleSide, indexBackWebSide } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/back/indexFinger'
import { middleBackIndexSide, middleBackRingSide } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/back/middleFinger'
import { ringBackLittleSide } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/back/ringFinger'
import { littleBackOut, littleBackRingSide } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/back/littleFinger'
import { backLaceDrawerOfFront } from 'src/features/brands/gorilla/canvas/common/useCanvasHelper'
import { rightLaceOfNetWebDrawer, webOfGloveFrontDrawer } from 'src/features/brands/gorilla/canvas/glove/rightThrow/front/web/useCanvasWebFront'
import { canvasResetter } from 'src/features/brands/gorilla/canvas/common/canvasResetter'
import { gorillaEngravedOfCatchFace } from 'src/features/brands/gorilla/canvas/labels/gorilla'
import { startInversion, undoInversion } from 'src/util/canvas'

export const gorillaCanvasGloveFrontLeftThrow = (ctx: CanvasRenderingContext2D, state: State, position: Position, canvasWidth: number): void => {
  const { indexWebColor, indexMiddleColor, middleIndexColor, middleRingColor, ringLittleColor, littleRingColor } = fingerColors(state) // RAGは baseModelで判定
  // リセット
  canvasResetter(ctx)

  startInversion(ctx, canvasWidth)
  // 裏革
  listLining(ctx, state.listLiningsMaterial?.color)
  // 背面の紐
  backLaceDrawerOfFront(ctx, state.backLace?.value, state.lace?.color, position)
  // ウェブの描画
  webOfGloveFrontDrawer(ctx, state, position)
  // 捕球面
  catchFace(ctx, state.catchFace?.color)
  // 親指背面＿外側
  thumbBackOut(ctx, state.thumbOut?.color)
  // 親指背面＿ウェブ側
  const thumbBackWebSideColor = state.thumbWeb?.value === 'unselected' ? state.thumbWebAndIndexWeb?.color : state.thumbWeb?.color
  thumbBackWebSide(ctx, thumbBackWebSideColor)
  // 人差し指背面＿ウェブ側
  indexBackWebSide(ctx, indexWebColor)
  // 人差し指背面＿中指側
  indexBackMiddleSide(ctx, indexMiddleColor)
  // 中指背面＿人差し指側
  middleBackIndexSide(ctx, middleIndexColor)
  // 中指背面＿薬指側
  middleBackRingSide(ctx, middleRingColor)
  // 薬指背面＿小指側
  ringBackLittleSide(ctx, ringLittleColor)
  // 小指背面＿薬指側
  littleBackRingSide(ctx, littleRingColor)
  // 小指背面＿外側
  littleBackOut(ctx, state.littleOut?.color)
  // ハミダシ
  hamidashi(ctx, state.hamidashi?.color)
  // ヘリ革
  edges(ctx, state.edge?.color, state.lace?.color, state.stitch?.color, position, state?.bankLaceDirection)
  // ネットウェブのみの革紐
  rightLaceOfNetWebDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color, state?.materialPack, position)

  undoInversion(ctx, canvasWidth)
  // メーカー捕球面の刻印
  gorillaEngravedOfCatchFace(ctx, state.catchFace?.color, -80, 0)
}

const fingerColors = (state: State) => {
  const indexWebColor = state?.indexWeb?.color
  const indexMiddleColor = state?.indexMiddle?.color
  const middleIndexColor = state?.middleIndex?.color
  const middleRingColor = state?.middleRing?.color
  const ringMiddleColor = state?.ringMiddle?.color
  const ringLittleColor = state?.ringLittle?.color
  const littleRingColor = state?.littleRing?.color

  return {
    indexWebColor,
    indexMiddleColor,
    middleIndexColor,
    middleRingColor,
    ringMiddleColor,
    ringLittleColor,
    littleRingColor
  }
}
